<template>
  <div>
    <MyPaymentsHead
        @toggleFilter="toggleFilter"
        :showFilter="showFilter"
        @changeTab="changeTab"
        :userTabs="userTabs"
        :countFilterParams="countFilterParams"
        @selectAll="selectAll"
        @printInvoice="(dateInvoice) => $emit('printInvoice', {date: dateInvoice, selected: true})"
    />

    <div class="table-filter-wrap">

      <MyPaymentsFilter
          :showFilter="showFilter"
          @close="closeFilter"
          @changeFilter="changeFilter"
          @resetFilter="$emit('resetFilter')"
          :filterGetParams="filterGetParams"
          :userTabs="userTabs"
      />

      <MyPaymentsTable
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          :userTabs="userTabs"
          :countFilterParams="countFilterParams"
          :selectedNow="selectedNow"
          @downloadFiles="type => $emit('downloadFiles', type)"
          @exportPdf="(id) => $emit('exportPdf', id)"
          @printInvoice="(data) => $emit('printInvoice', data)"
      />
    </div>
  </div>
</template>

<script>


  import MyPaymentsHead from "./MyPaymentsHead/MyPaymentsHead";
  import MyPaymentsTable from "./MyPaymentsTable/MyPaymentsTable";
  import MyPaymentsFilter from "./MyPaymentsFilter/MyPaymentsFilter";

  export default {
    name: "MyPaymentsTableUser",

    components: {
      MyPaymentsHead,
      MyPaymentsTable,
      MyPaymentsFilter,
    },

    props: ['userTabs', 'filterGetParams', 'typeShops', 'countFilterParams'],

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      changeShopType(index) {
        this.$emit('changeShopType', index)
      },

      changeFilter(data) {
        this.$emit('changeFilter', data)
      },

      changeTab(id) {
        this.$emit('changeTab', id)
      },

      selectAll(val) {
        this.selectedNow = val
      },

    }
  }
</script>

<style scoped>

</style>
